import { useEffect, useState } from "react";
import { Loader2, Clock } from "lucide-react";
import { api } from "@/lib/api";

export function ActivityTimeline({ entityType, entityId, refreshKey }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    if (!entityId) return;
    api.get("/admin/activities", { params: { entity_type: entityType, entity_id: entityId } })
      .then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [entityType, entityId, refreshKey]);

  if (items === null) return <div className="flex justify-center py-4"><Loader2 className="h-4 w-4 animate-spin text-slate-400" /></div>;
  if (items.length === 0) return <p className="text-sm text-slate-400">No activity recorded yet.</p>;

  return (
    <div className="relative space-y-3 pl-4" data-testid="activity-timeline">
      <div className="absolute left-[6px] top-1 h-[calc(100%-0.5rem)] w-px bg-slate-200" />
      {items.map((a) => (
        <div key={a.id} className="relative">
          <span className="absolute -left-4 top-1 h-3 w-3 rounded-full border-2 border-white bg-brand" />
          <p className="text-sm font-semibold text-slate-800">{a.action}</p>
          {a.detail && <p className="text-xs text-slate-500">{a.detail}</p>}
          <p className="flex items-center gap-1 text-[11px] text-slate-400"><Clock size={11} /> {new Date(a.created_at).toLocaleString("en-IN")}{a.admin ? ` · ${a.admin}` : ""}</p>
        </div>
      ))}
    </div>
  );
}
